var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"up-button",attrs:{"df":"","fdr":"","fjc":"","fic":""},on:{"click":function($event){return _vm.scrollMove()}}},[_c('img',{attrs:{"src":"/assets/main/arrow-up.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }